import htmx from "htmx.org";
import "preline";
import * as hyperscript from "hyperscript.org";
import _ from "lodash";
import ApexCharts from "apexcharts";

window.htmx = htmx;
window._ = _;
window.ApexCharts = ApexCharts;
htmx.config.historyRestoreAsHxRequest = false;

hyperscript.browserInit();
window.HSStaticMethods.autoInit();

htmx.onLoad(function () {
  window.HSStaticMethods.autoInit();
});

document.body.addEventListener("htmx:afterSwap", function (evt) {
  window.HSStaticMethods.autoInit();
});

// HTMX Error Handling
document.body.addEventListener("htmx:responseError", function (evt) {
  console.error("HTMX Response Error:", evt.detail);

  // Create and dispatch toast event for response errors
  const toastEvent = new CustomEvent("toast", {
    detail: {
      level: "error",
      message: `Request failed: ${evt.detail.xhr.status} ${
        evt.detail.xhr.statusText || "Unknown error"
      }`,
    },
  });
  document.body.dispatchEvent(toastEvent);
});

document.body.addEventListener("htmx:sendError", function (evt) {
  console.error("HTMX Send Error:", evt.detail);

  // Create and dispatch toast event for network/send errors
  const toastEvent = new CustomEvent("toast", {
    detail: {
      level: "error",
      message: "Network error: Could not complete request",
    },
  });
  document.body.dispatchEvent(toastEvent);
});

// Optional: Handle timeout errors
document.body.addEventListener("htmx:timeout", function (evt) {
  console.error("HTMX Timeout:", evt.detail);

  const toastEvent = new CustomEvent("toast", {
    detail: {
      level: "warning",
      message: "Request timed out. Please try again.",
    },
  });
  document.body.dispatchEvent(toastEvent);
});

// Service Worker Registration - Global (needed to receive push notifications)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      await navigator.serviceWorker.register("/static/scripts/service-worker.js");
      console.log("Service worker registered successfully");
    } catch (err) {
      console.error("SW registration failed:", err);
    }
  });
}
